export default {
  "footer": "_footer_r95zzi",
  "footer-checkbox": "_footer-checkbox_r95zzi"
};